import { axiosInstance } from './common';

export const getDataCapturesList = () => axiosInstance.get(`/datacapture/list`).then((response) => response.data);

export const getDataCapture = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/${dataCaptureId}`).then((response) => response.data);

export const getStreamingLink = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/streaming/${dataCaptureId}`).then((response) => response.data);
